<template lang="pug">
    <div class="c-pager" v-if="count > 0">
      <ul class="c-pager__box">
        <li v-show="isFirst">
          <span @click="update(1)">&lt;&lt;</span>
        </li>
        <li v-show="isPrev">
          <span @click="update(Number(page) - 1)">&lt;</span>
        </li>
        <li v-for="(item , index) in pager" :key="index" :class="{ 'c-pager__box__on': Number(item) === Number(page)}">
          <span
            v-if="Number(item) !== Number(page)"
            @click="update(item)"
          >{{item}}</span>
          <span v-else >{{item}}</span>
        </li>
        <li v-show="isNext">
          <span @click="update(Number(page) + 1)">&gt;</span>
        </li>
        <li v-show="isLast">
          <span @click="update(totalPage)">&gt;&gt;</span>
        </li>
      </ul>
    </div>

</template>

<script>
export default {
  name: 'CommonPager',
  props: ['update', 'size', 'page', 'count'],
  data() {
    return {
      pager: [],
      isPrev: false,
      isNext: false,
      isFirst: false,
      isLast: false,
    };
  },
  computed: {
    cardGroupMount() {
      return Math.ceil(this.proplist.length / 4);
    },
    totalPage() {
      return Math.ceil(Number(this.count) / Number(this.size));
    },
  },
  mounted() {
    const t = Math.ceil(this.count / this.size);
    this.pager = [];

    // isPrev,isNext,isFirst,isLast
    if (this.page > 1 && t > 1) this.isPrev = true;
    if (this.page > 0 && t > 1 && Number(this.page) !== Math.ceil(t)) this.isNext = true;
    if (Number(this.page) > 3) this.isFirst = true;
    if (Number(this.page) < (t - 2)) this.isLast = true;

    // pager埋める
    if (Number(this.page) - 2 > 0) this.pager.push(Number(this.page) - 2);
    if (Number(this.page) - 1 > 0) this.pager.push(Number(this.page) - 1);
    this.pager.push(Number(this.page));
    if (Number(this.page) < t) this.pager.push(Number(this.page) + 1);
    if (Number(this.page) + 1 < t) this.pager.push(Number(this.page) + 2);
  },
  methods: {
    cardBlocks(startIndex) {
      const tmp = this.proplist.concat();
      return tmp.slice(startIndex * 4, (startIndex * 4) + 4);
    },

  },

};
</script>

<style scoped lang="scss">
.c-pager {
    padding: 20px 40px;
  &__box {
    display: flex;
    // align-items: center;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    li {
      display:flex;
      justify-content: center;
      align-items: center;
      height: 36px;
      width: 36px;
      border: 1px solid #707070;
      border-radius: 18px;
      margin: 10px 5px;
      font-size: 15px;
      cursor: pointer;
      span {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__on {
      background-color: #E83532;
      border: 1px solid #E83532 !important;
      color: #FFF;
      cursor: default !important;

    }
  }
}

@media screen and (max-width: 767px) {
  .c-pager {
    padding: 20px 0px;
  }
}
</style>
